import { render } from "./ActionsModal.vue?vue&type=template&id=0a0bef63"
import script from "./ActionsModal.vue?vue&type=script&lang=js"
export * from "./ActionsModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__